// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper__JwLbw","searchfield":"searchfield__p7oQL","closed":"closed__uXKed","close":"close__xyjj1","filter-search":"filter-search__cqLVf","filterbox":"filterbox__aILQm"};